import { executionRunFragment } from './fragments';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const executionRunCancelAtom = createMutationAtomFactory(
  'automations.executionRunCancel',
  (params: { id: string }) => ({
    automationsExecutionRunCancel: {
      __args: {
        id: params.id,
      },
      ...executionRunFragment,
    },
  }),
)();
